import {InputAdornment} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {Visibility, VisibilityOff} from "@mui/icons-material";

interface CustomEyePassword {
    show: boolean
    toggle: () => void
}
export const EyePassword = ({show, toggle}: CustomEyePassword) => {
    return (
        <InputAdornment position="end">
            <IconButton
                onClick={toggle}
            >
                {show ? <Visibility/> : <VisibilityOff/>}
            </IconButton>
        </InputAdornment>
    );
};